import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Wrapper, Header, CellContainer, GridColumn } from './styled';
import StatusCell from '../../status-cell';
import { mapOrder, getFirstStatusOccurrences } from '../grid-util';
import { SCHEDULED_ASSIGN, getStatus, statusCodes } from '../../status-cell/utils';


const CollapsedGrid = (props) => {
  const { learningJourneyIds, i18n } = props;
  let { assignmentStatuses } = useSelector(state => state.UPFAssignReducer);
  const { filteredStudents, sortedStudents, selectedTopics } = useSelector(state => state.UPFAssignReducer);
  const filteredStudentsIds = filteredStudents.map(student => student.id) || [];

  assignmentStatuses = mapOrder(assignmentStatuses, sortedStudents.map(student => student.id));

  return (<Wrapper>
    <Header />
    <GridColumn>
      {
        sortedStudents.map((sortedStudent) => {
          const { id } = sortedStudent;

          if (filteredStudentsIds.includes(id)) {
            const students = assignmentStatuses.filter(status => status.studentProfileId === id);
            let stepsCount = 0;
            let stepsCompleted = 0;
            const firstStatusOccurrences =
              getFirstStatusOccurrences(selectedTopics, assignmentStatuses, id);
            let isFirstOfStatus = false;
            let isScheduled = false;
            learningJourneyIds.forEach((ljId) => {
              students.forEach((student) => {
                const cellStatus = getStatus(student.studentStatus);
                if (student.learningJourneyId === ljId) {
                  stepsCount += student.stepsCount;
                  stepsCompleted += student.stepsCompleted;
                  if (cellStatus === SCHEDULED_ASSIGN && firstStatusOccurrences[student.studentStatus] === ljId) {
                    isFirstOfStatus = true;
                  }
                  if (cellStatus === SCHEDULED_ASSIGN) {
                    isScheduled = true;
                  }
                }
              });
            });

            const studentInfo = {
              stepsCompleted,
              stepsCount
            };
            if (isFirstOfStatus || isScheduled) {
              studentInfo.studentStatus = SCHEDULED_ASSIGN;
            }

            return (<CellContainer key={id}>
              <StatusCell
                studentInfo={studentInfo}
                i18n={i18n}
                showResult={studentInfo.stepsCount > 0}
                isFirstOfStatus={isFirstOfStatus}
                showSchedule={!!firstStatusOccurrences[statusCodes[SCHEDULED_ASSIGN]]}
              />
            </CellContainer>);
          }
          return null;
        })
      }
    </GridColumn>
  </Wrapper>);
};

CollapsedGrid.propTypes = {
  learningJourneyIds: PropTypes.array,
  i18n: PropTypes.object
};

CollapsedGrid.defaultProps = {
  learningJourneyIds: []
};

export default CollapsedGrid;
